import { FormattedMessage } from 'react-intl';

import './SourceCard.sass';

const DefaultSource = ({ loading, isSimple = false }: { loading?: boolean; isSimple?: boolean }) => {
	return (
		<article className={`source-card default-source ${loading ? 'loading' : ''}`}>
			{!isSimple && <div className="source-image" />}
			<div className="source-info">
				<header>
					{loading && (
						<h2>
							<FormattedMessage id="loading" />
						</h2>
					)}
				</header>
				<p>
					<span className="row-empty" />
					<span className="row-empty" />
					<span className="row-empty" />
				</p>
			</div>
		</article>
	);
};

export default DefaultSource;
